module.exports = __webpack_public_path__ + "static/media/hrcom-vid-ar.3b970a7d.mp4";